import { ApiError, ForbiddenError, ShipmentBookingError, ValidationError } from '../../api/errors';

/**
 * Operator-facing text for a failed Cargonizer booking. Raw backend strings
 * aren't shown (see AGENTS.md); each stable reason gets an actionable
 * message instead.
 */
export function bookingErrorMessage(error: unknown): string {
  if (error instanceof ShipmentBookingError) {
    switch (error.reason) {
      case 'INVALID_ADDRESS':
        return 'The address is incomplete. Enter a street, postcode and city.';
      case 'REVERSED_ENDPOINTS':
        return 'Origin and destination look reversed. A return goes from a customer site to a Tidal location; an outbound shipment goes from Tidal to a customer.';
      case 'UNSUPPORTED_PRODUCT':
        return 'This carrier or product can’t be booked in this direction. Choose another carrier.';
      case 'PROVIDER_REJECTED':
        return 'Cargonizer rejected the booking. Check the address, weights and dimensions, then try again.';
      case 'PROVIDER_AUTH_FAILED':
        return 'Cargonizer refused koi’s credentials, so nothing was booked. Ask an administrator to check the Cargonizer API key.';
      case 'PROVIDER_UNAVAILABLE':
        return 'Cargonizer could not be reached, so nothing was booked. Try again in a few minutes.';
      case 'MISSING_MEASUREMENTS':
        return 'Every package needs its weight, length, width and height. Carriers charge extra for missing measurements.';
      case 'NOT_PERSISTED':
        return `Cargonizer booked the consignment, but koi could not save it. Void it in Cargonizer before trying again. ${error.message}`;
    }
  }
  if (error instanceof ForbiddenError) return 'You do not have permission to book shipments.';
  if (error instanceof ValidationError) return 'Check the shipment details and try again.';
  if (error instanceof ApiError && error.code === 'UNAUTHENTICATED') return error.message;
  return 'The shipment could not be booked.';
}

// A network failure means the booking may or may not have been made.
export function isUnknownOutcome(error: unknown): boolean {
  return error instanceof ApiError && error.code === 'NETWORK';
}
